<template>
	<div>
		<el-form
		    ref='ruleFormRef'
		    v-loading='loading'
		    element-loading-text='正在识别中...'
		    label-width='100px'
		    class='demo-ruleForm'
		    :label-position='labelPosition'
		>
		    <el-form-item label='选择图片' prop='fontNum' required>
		        <div class='lzUpload'>
		            <lz-upload
		                ref='lzUpload'
		                style='width:140px;height: 140px;'
		                :max-count='1'
		                :width='140'
		                :height='140'
		                :file-list='fileList'
		                @on-choose-complete='chooseComplete'
		                @on-remove='chooseRemove'
		            />
		            <el-timeline class='timeline'>
		                <el-timeline-item timestamp='在空白白纸上盖上印章'>第一步</el-timeline-item>
		                <el-timeline-item timestamp='拍摄刚才盖好的章，上传到这里'>第二步</el-timeline-item>
		            </el-timeline>
		        </div>
		    </el-form-item>
		    <el-form-item label='生成结果' required>
		        <el-image v-if='canvasUrl' :src='canvasUrl' :preview-src-list='[canvasUrl]' />
		    </el-form-item>
		</el-form>
		<canvas id='canvas' style='display: none;' />
	</div>
</template>

<script>
let that
	import lzUpload from "@/components/lzUpload/lzUpload"
	export default {
		props: ['labelPosition','canvasUrl'],
		components: {
			lzUpload
		},
		data() {
			return {
				fileList:[],
				loading:false,
				canvas:null,
				context: null,
				cuttingPoint: [{ x:0,y:0 },{ x:0,y:0 }],
				myImage:null,
				colorRange:0,
				imageData:null,
			}
		},
		mounted() {
			that = this
			this.canvas = document.getElementById('canvas')
			this.context = this.canvas.getContext('2d')
		},
		methods: {
			chooseComplete(e){
				this.loading = true
				if (e && e.length > 0) {
				    try{
				        this.fileToBase64(e[0].file).then(res => {
				            this.imageData = res
				            this.drawImage((base64) => {
				                this.loading = false
				                this.$emit('updateCanvasUrl', base64)
				            })
				        })
				    }catch(e) {
				        this.loading.value = false
				    }
				}
			},
			fileToBase64(file){
			    return new Promise((resolve, reject) => {
			        let reader = new FileReader()
			        let fileResult = ''
			        reader.readAsDataURL(file)
			        reader.onload = function() {
			            fileResult = reader.result
			        }
			        reader.onerror = function(error) {
			            reject(error)
			        }
			        reader.onloadend = function() {
			            resolve(fileResult)
			        }
			    })
			},
			chooseRemove(index, lists, name){
			    this.fileList = []
			    this.imageData = ''
			},
			drawImage(callback){
			    const image = new Image()
			    image.src = this.imageData
			    image.onload = (e) => {
			        this.canvas.width = image.width
			        this.canvas.height = image.height
			        this.context.drawImage(image, 0, 0)
			        this.setColorData()
			        this.exportSeal(callback)
			    }
			},
			setColorData(){
			    let length = this.canvas.width * this.canvas.height
			    this.myImage = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height)
			    for (let i = 0; i < length * 4; i += 4) {
			        let myRed = this.myImage.data[i]
			        let myGreen = this.myImage.data[i + 1]
			        let myBlue = this.myImage.data[i + 2]
			        if (!this.colorInRange(myRed, myGreen, myBlue)) {
			            this.myImage.data[i + 3] = 0
			        }
			        if (this.myImage.data[i] > 70) {
			            this.myImage.data[i] = 230
			        }
			    }
			    this.context.putImageData(this.myImage, 0, 0)
			},
			colorInRange(red, green, blue){
			    if (red >= this.colorRange && green >= this.colorRange && blue >= this.colorRange && ((red - green) > 20)) {
			        return true
			    }
			    return false
			},
			exportSeal(callback){
			    let length = this.canvas.width * this.canvas.height
			    this.myImage = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height)
			    this.cuttingPoint[0].y = this.leftPoint(length, this.myImage)
			    this.cuttingPoint[0].x = this.topPoint(length, this.myImage)
			    this.cuttingPoint[1].y = this.bootomPoint(length, this.myImage)
			    this.cuttingPoint[1].x = this.rightPoint(length, this.myImage)
			    let image = new Image()
			    image.src = this.canvas.toDataURL('image/png')
			    image.onload = ()=> {
			        let canvas = document.createElement('canvas')
			        canvas.width = this.cuttingPoint[1].x - this.cuttingPoint[0].x
			        canvas.height = this.cuttingPoint[1].y - this.cuttingPoint[0].y
			        let context = canvas.getContext('2d')
			        context.drawImage(image, this.cuttingPoint[0].x, this.cuttingPoint[0].y, canvas.width, canvas.height, 0, 0,canvas.width, canvas.height)
			        if(callback) {
			            callback(canvas.toDataURL())
			        }                  
			    }
			},
			topPoint (length, myImage) {
			    for (let i = 0; i < this.canvas.width; i += 1) {
			        for (let j = 0; j < this.canvas.height; j++) {
			            let myRed = this.myImage.data[j * this.canvas.width * 4 + i * 4]
			            if (myRed >= 10) {
			                return i
			            }
			        }
			    }
			},
			bootomPoint(length, myImage){
			    for (let i = length * 4 - 4; i >= 4; i -= 4) {
			        let myRed = this.myImage.data[i]
			        if (myRed >= 10) {
			            return Math.ceil(i / 4 / this.canvas.width)
			        }
			    }
			},
			leftPoint(length, myImage){
			    for (let i = 0; i < length * 4; i += 4) {
			        let myRed = this.myImage.data[i]
			        if (myRed >= 10) {
			            return Math.ceil(i / 4 / this.canvas.width)
			        }
			    }
			},
			rightPoint(length, myImage){
			    for (let i = this.canvas.width - 1; i > 0; i--) {
			        for (let j = this.canvas.height; j > 0; j--) {
			            let myRed = this.myImage.data[(this.canvas.height - j) * this.canvas.width * 4 + i * 4]
			            if (myRed >= 10) {
			                return i
			            }
			        }
			    }
			}
		}
	}
</script>

<style lang="scss" scoped>
	.lzUpload{
		height:140px;display:flex;
	}
	.timeline{
		margin-left:20px;
	}
</style>


// WEBPACK FOOTER //
// src/components/drawElectronicSeal/imageRecognition.vue